/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Col_PositionInputs */

const vi_sinp_col_position = /** @type {(inputs: Sinp_Col_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí`)
};

/**

* @param {Sinp_Col_PositionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_col_position = /** @type {((inputs?: Sinp_Col_PositionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Col_PositionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_col_position(inputs)
});